/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import "./system-parameters.styles.scss";
import {
  Input,
  Button,
  TimePicker,
  Radio,
  Modal,
  Spin,
  message,
  Switch,
  Row,
  Col,
  Typography,
} from "antd";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import {
  // getSysParams,
  putSysParams,
  getDiscountParams,
} from "../../services/sys-params-services";

import {
  selectBranches,
  selectVarieties,
  selectCrops,
  selectSelectedCrop,
  selectCurrentPage,
  selectBranchParams,
  selectCropParams,
  selectSelectedBranch,
  selectViewAuctionPage,
} from "../../redux/common/common.selectors";
// import { setBranchIndex } from "../../redux/common/common.actions";
import { Dispatch } from "redux";

import CustomSelect from "../../components/custom-select/custom-select.component";

import { Select } from "antd";

import { canUserAccess } from "../../utils/utils";
import { FeatureCodes } from "../../constants/data-constants";

import dayjs from "dayjs";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";
import {
  setBranchParamsRefetch,
  setSelectedBranch,
  setSelectedCrop,
} from "../../redux/common/common.actions";
import {
  getBagTypeDetails,
  getCropYearDetails,
} from "../../services/auction-services";
import { useLocation } from "react-router";

const { Option } = Select;

const formD: any = {
  minimum_quantity: "",
  auction_closing_duration: "",
  saudha_type: "",
  price_tick_size: "",
  minimum_price_decrement: "",
  cash_discount: "",
  cash_discount_desc: "",
  minimum_refund_amount: "",
  bag_type: "",
  crop_year: "",
  send_wa_upcoming: "",
  Brokerage: "",
};

const formParamD: any = {
  avg_commodity_price: "",
  caution_deposit_min_amount: "",
  safety_margin: "",
  minimum_price_decrement_percentage: "",
};

const SystemParameters: React.FC = (props: any) => {
  const {
    branches,
    user,
    crops,
    selectedCrop,
    currentpage,
    branchParams,
    selectedBranch,
    setCrop,
    setBranch,
    viewAuctionPage,
    cropParams,
    setRefetch,
    authData,
  } = props;
  const [formData, setFormData] = useState(formD);
  const [branchLoading, setBranchLoading] = useState(false);
  const [sysLoading, setSysLoading] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [bagType, setBagType] = useState([]);
  const [cropYear, setCropYear] = useState([]);
  const [cashDiscountDesc, setCashDiscountDesc] = useState<any>();
  const [formParamData, setFormParamData] = useState(formParamD);
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.includes("/preferences/auctionpreferences")) {
      setFormData(branchParams);
      setFormParamData(cropParams);
      getDiscount(branchParams);
    }
  }, [
    authData.access_token,
    currentpage,
    branchParams,
    cropParams,
    selectedBranch,
  ]);
  useMemo(async () => {
    try {
      const bagTypeResponse = await getBagTypeDetails();
      if (bagTypeResponse.data.status) {
        setBagType(bagTypeResponse.data.data);
      }
      const cropYearResponse = await getCropYearDetails();
      if (cropYearResponse.data.status) {
        setCropYear(cropYearResponse.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [authData.access_token]);
  const getDiscount = async (branchParams: any) => {
    try {
      const discountResponse = await getDiscountParams({
        crop_id: selectedCrop,
        branch_id: selectedBranch,
      });
      var tempData: any = [];
      tempData = discountResponse.data.data;
      setDiscounts(tempData);
      setCashDiscountDesc(
        tempData?.filter(
          (item: any) =>
            item.cash_discount_id.toString() === branchParams.cash_discount
        ).length > 0
          ? tempData?.filter(
              (item: any) =>
                item.cash_discount_id.toString() === branchParams.cash_discount
            )[0]
          : tempData.length > 0 && tempData[0]
      );
    } catch (error: any) {
      console.log(error);
      // message.error(
      //   error.response.data.message ||
      //     "Something went wrong, please try again later.",
      // );
    }
  };

  const onChangeInput = (value: any, field: string, variety?: number) => {
    if (field === "cash_discount") {
      setCashDiscountDesc(
        discounts?.filter((item: any) => item.cash_discount_id == value)
          .length &&
          discounts?.filter((item: any) => item.cash_discount_id == value)[0]
      );
      setFormData({
        ...formData,
        cash_discount: value,
      });
    } else if (field === "send_wa_upcoming") {
      setFormData({
        ...formData,
        send_wa_upcoming: value === true ? "1" : "0",
      });
    } else if (field === "minimum_quantity") {
      const tempValue = String(value).replace(/\D/, "");
      setFormData({ ...formData, [field]: tempValue });
    } else {
      setFormData({ ...formData, [field]: value });
    }
  };

  const onChangeInputForParam = (
    value: any,
    field: string,
    variety?: number
  ) => {
    var numberRegex = /^[0-9.]+$/;
    if (value === "") {
      setFormParamData({ ...formParamData, [field]: value });
    } else if (value.match(numberRegex)) {
      setFormParamData({ ...formParamData, [field]: value });
    }
  };

  const onChangeTime = (timeString: string, key: string) => {
    if (
      timeString === "00:00" ||
      timeString === "00:01" ||
      timeString === "00:02" ||
      timeString === "00:03" ||
      timeString === "00:04"
    ) {
      message.warning(
        "Minimum Auction Buffer Time Should be set to 5 Minutes..."
      );
    } else {
      setFormData({ ...formData, [key]: timeString });
    }
  };

  const onUpdate = async (
    keys: Array<string>,
    form: number,
    onCautionParamUpdate: boolean
  ) => {
    var tempData: any[] = [];
    if (form === 3) {
      tempData = formData.cash_discount.map((item: any) => {
        return {
          data_value: item.cash_discount,
          variety_id: item.variety_id,
          parameter_type: "cash_discount",
        };
      });
    } else if (onCautionParamUpdate) {
      tempData = keys.map((key) => {
        return {
          data_value: formParamData[key],
          parameter_type: key,
        };
      });
    } else {
      tempData = keys.map((key) => {
        if (key === "inco_terms") {
          return {
            data_value: formData[key].toUpperCase(),
            parameter_type: key,
          };
        } else {
          return {
            data_value: formData[key],
            parameter_type: key,
          };
        }
      });
    }
    var dataToSend: any = {
      branch_id: null,
      parameters: tempData,
      crop_id: selectedCrop,
    };
    var messageString = "";
    switch (form) {
      case 1:
        setBranchLoading(true);
        dataToSend = {
          ...dataToSend,
          branch_id: selectedBranch,
        };
        messageString = "Updated branch level param...";
        break;
      case 2:
        setSysLoading(true);
        if (onCautionParamUpdate) {
          dataToSend = {
            ...dataToSend,
            crop_id: selectedCrop,
          };
          messageString = "Updated company level param...";
        } else {
          messageString = "Updated company level param...";
        }

        break;
    }

    const validate = () => {
      for (let i = 0; i < dataToSend.parameters.length; i++) {
        switch (dataToSend.parameters[i].parameter_type) {
          case "minimum_quantity":
            if (
              parseInt(dataToSend.parameters[i].data_value) <= 0 ||
              isNaN(parseInt(dataToSend.parameters[i].data_value))
            ) {
              message.warning("Enter a valid minimum quantity...");
              return false;
            }
            break;
          case "auction_closing_duration":
            if (dataToSend.parameters[i].data_value == "00:00:00") {
              message.warning("Enter a valid duration...");
              return false;
            }
            break;
          case "price_tick_size":
            if (
              parseInt(dataToSend.parameters[i].data_value) <= 0 ||
              isNaN(parseInt(dataToSend.parameters[i].data_value))
            ) {
              message.warning("Enter a valid tick size...");
              return false;
            }
            break;
          case "minimum_price_decrement":
            dataToSend.parameters[i].data_value =
              dataToSend.parameters[i].data_value / 100;
            if (
              dataToSend.parameters[i].data_value <= 0 ||
              dataToSend.parameters[i].data_value > 1
            ) {
              message.warning("Enter a valid price decrement...");
              return false;
            }
            break;
          case "minimum_price_decrement_percentage":
            dataToSend.parameters[i].data_value =
              dataToSend.parameters[i].data_value / 100;
            if (
              dataToSend.parameters[i].data_value <= 0 ||
              dataToSend.parameters[i].data_value > 1
            ) {
              message.warning("Enter a valid price decrement...");
              return false;
            }
            break;
          case "cash_discount":
            // if (isNaN(parseInt(dataToSend.parameters[i].data_value))) {
            if (
              !dataToSend.parameters[i].data_value ||
              dataToSend.parameters[i].data_value === ""
            ) {
              message.warning("Enter cash discount...");
              return false;
            }
            // if (
            //   dataToSend.parameters[i].data_value < 0 ||
            //   dataToSend.parameters[i].data_value > 100
            // ) {
            //   message.warning("Enter cash discount...");
            //   return false;
            // }
            break;
          case "bag_type":
            if (
              !dataToSend.parameters[i].data_value ||
              dataToSend.parameters[i].data_value === ""
            ) {
              message.warning("Enter bag type...");
              return false;
            }
            break;
          case "crop_year":
            if (
              !dataToSend.parameters[i].data_value ||
              dataToSend.parameters[i].data_value === ""
            ) {
              message.warning("Enter crop year...");
              return false;
            }
            break;
        }
      }
      return true;
    };

    if (validate()) {
      try {
        let updateResponse;
        if (onCautionParamUpdate) {
          updateResponse = await putSysParams(dataToSend);
        } else {
          updateResponse = await putSysParams(dataToSend);
        }
        if (updateResponse.data.status) {
          message.success(messageString, 1.5);
        } else {
          message.error(
            "Something went wrong, could not update params..!",
            1.5
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
    setRefetch(true);
    setBranchLoading(false);
    setSysLoading(false);
  };

  // const onCropSelected = (value: number) => {
  //   setCrop(value);
  //   getParamsFnForCrop(value);
  // };

  // const onSelectedBranch = (value: number) => {
  //   setBranch(value);
  //   getDiscounts(selectedCrop, value);
  //   // getParamsFn(value, true);
  // };

  function onChangeDiscount(value: any) {
    onChangeInput(value, "cash_discount");
  }

  return (
    <div className="system-params">
      {(canUserAccess(user, FeatureCodes.COMPANY_LEVEL_PREFERENCES) ||
        canUserAccess(user, FeatureCodes.ACCESS_EDIT_COMPANY_LEVEL_PARAM)) && (
        <div style={{ display: "flex" }}>
          <div className="left-container">
            <Spin spinning={sysLoading}>
              <div className="outer-container">
                <div className="header">Company Level Parameters</div>
                <div className="form-container">
                  <div>Auction Freeze Period (Minutes)</div>
                  <Input
                    type="number"
                    placeholder="Auction Freeze Period"
                    min={1}
                    max={60}
                    value={formData.auction_freeze_period}
                    onChange={(e) =>
                      onChangeInput(e.target.value, "auction_freeze_period")
                    }
                  />
                  <div>Max Qty parameter</div>

                  <Input
                    type="number"
                    placeholder="Max Qty parameter"
                    min={1}
                    max={100}
                    value={formData.max_qty_parameter}
                    onChange={(e) =>
                      onChangeInput(e.target.value, "max_qty_parameter")
                    }
                  />
                  <div>Minimum Refund Amount(₹) </div>

                  <Input
                    type="number"
                    placeholder="Minimum Refund Amount"
                    min={1}
                    value={formData.minimum_refund_amount}
                    onChange={(e) =>
                      onChangeInput(e.target.value, "minimum_refund_amount")
                    }
                  />
                  <div>Price Tick Size</div>
                  <div className="price-tick-size" style={{ height: "32px" }}>
                    {formData.price_tick_size}
                  </div>
                  <div>Inco Terms</div>
                  <div className="price-tick-size" style={{ height: "32px" }}>
                    {formData.inco_terms}
                  </div>
                  <div className="update-btn">
                    <Button
                      disabled={
                        formData.max_qty_parameter === "" ||
                        formData.inco_terms === "" ||
                        formData.auction_freeze_period === ""
                        // ||
                        // formData.minimum_price_decrement === ""
                      }
                      type="primary"
                      onClick={() =>
                        onUpdate(
                          [
                            "price_tick_size",
                            // "minimum_price_decrement",
                            "auction_freeze_period",
                            "inco_terms",
                            "max_qty_parameter",
                            "minimum_refund_amount",
                          ],
                          2,
                          false
                        )
                      }
                    >
                      Update
                    </Button>
                  </div>
                </div>
              </div>
            </Spin>
          </div>
          <div className="left-container" style={{ marginLeft: "10px" }}>
            <Spin spinning={sysLoading}>
              <div className="outer-container" style={{ width: "520px" }}>
                <div className="header">
                  Company Level Parameters for
                  <CustomSelect
                    isCropParam={true}
                    options={crops}
                    value={selectedCrop}
                    onChange={(value: any) => setCrop(value)}
                    returnId
                  />
                </div>
                <div className="form-container">
                  <div>Minimum Price Distribution % from Max Price</div>
                  <Input
                    type="number"
                    placeholder="Minimum Price Distribution"
                    min={1}
                    max={100}
                    value={formParamData.minimum_price_decrement_percentage}
                    onChange={(e) =>
                      onChangeInputForParam(
                        e.target.value,
                        "minimum_price_decrement_percentage"
                      )
                    }
                  />
                  <div>Minimum Caution Deposit Amount(₹)</div>
                  <Input
                    type="number"
                    // placeholder="Minimum Caution Deposit Amount"
                    min={1}
                    max={100}
                    value={formParamData.caution_deposit_min_amount}
                    onChange={(e) =>
                      onChangeInputForParam(
                        e.target.value,
                        "caution_deposit_min_amount"
                      )
                    }
                  />
                  <div>
                    Avg Commodity Price(
                    {crops?.find((item) => item.id == selectedCrop)?.unit})
                  </div>
                  <Input
                    type="number"
                    // placeholder="Avg Commodity Price"
                    min={1}
                    max={60}
                    value={formParamData.avg_commodity_price}
                    onChange={(e) =>
                      onChangeInputForParam(
                        e.target.value,
                        "avg_commodity_price"
                      )
                    }
                  />
                  <div>Caution Deposit Safety Margin(%)</div>
                  <Input
                    type="number"
                    // placeholder="Caution Deposit Safety Margin"
                    min={1}
                    max={100}
                    value={formParamData.safety_margin}
                    onChange={(e) =>
                      onChangeInputForParam(e.target.value, "safety_margin")
                    }
                  />
                  <div className="update-btn" style={{ marginTop: "2%" }}>
                    <Button
                      type="primary"
                      onClick={() =>
                        onUpdate(
                          [
                            "minimum_price_decrement_percentage",
                            "caution_deposit_min_amount",
                            "avg_commodity_price",
                            "safety_margin",
                          ],
                          2,
                          true
                        )
                      }
                    >
                      Update
                    </Button>
                  </div>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      )}
      {(canUserAccess(user, FeatureCodes.VIEW_ONLY_ACCESS) ||
        canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES)) && (
        <Spin spinning={branchLoading}>
          <Typography.Title level={5} style={{ textAlign: "left" }}>
            Add Auction Preferences
          </Typography.Title>
          <Row gutter={24}>
            <Col span={12} style={{ textAlign: "left" }}>
              <div style={{ marginBlock: "10px 7px" }}>
                <label style={{ color: "red" }}>* </label>
                Select Crop
              </div>
              <CustomSelect
                options={crops}
                value={selectedCrop}
                onChange={(value: any) => setCrop(value)}
                className="set-height"
                returnId
              />
            </Col>
            <Col span={12} style={{ textAlign: "left" }}>
              <div style={{ marginBlock: "10px 7px" }}>
                <label style={{ color: "red" }}>* </label>
                Place/City
              </div>
              <CustomSelect
                options={branches}
                value={selectedBranch}
                onChange={(value: any) => setBranch(value)}
                className="set-height"
                returnId
              />
            </Col>
            <Col sm={24} lg={12} style={{ textAlign: "left" }}>
              <div style={{ marginBlock: "10px 7px" }}>
                <label style={{ color: "red" }}>* </label>
                Minimum Truckable Quantity (
                {crops?.find((item) => item.id == selectedCrop)?.unit})
              </div>
              <Input
                type="string"
                min={1}
                max={100}
                placeholder="Minimum Quantity"
                value={formData.minimum_quantity}
                onChange={(e) =>
                  onChangeInput(e.target.value, "minimum_quantity")
                }
                disabled={
                  !canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES)
                }
              />
            </Col>
            <Col sm={24} lg={12} style={{ textAlign: "left" }}>
              <div style={{ marginBlock: "10px 7px" }}>
                <label style={{ color: "red" }}>* </label>
                Cash Discount
              </div>
              <Select
                showSearch
                style={{ width: "100%", borderRadius: 10, textAlign: "left" }}
                value={
                  cashDiscountDesc &&
                  `${cashDiscountDesc.cash_discount_description} ( ${cashDiscountDesc.cash_discount_code} )`
                }
                disabled={
                  !canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES)
                }
                // value={formData.cash_discount}
                onChange={onChangeDiscount}
                placeholder="Select cash discount"
                optionFilterProp="children"
              >
                {discounts.map((v: any, i) => {
                  return (
                    <Option key={i} value={v.cash_discount_id}>
                      {v.cash_discount_description} ( {v.cash_discount_code} )
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col sm={24} lg={12} style={{ textAlign: "left" }}>
              <div style={{ marginBlock: "10px 7px" }}>
                <label style={{ color: "red" }}>* </label>
                Auction Buffer Time (HH:mm)
              </div>
              <TimePicker
                allowClear={false}
                showNow={false}
                format="HH:mm"
                placeholder="HH:mm"
                value={dayjs(formData.auction_closing_duration, "HH:mm")}
                onChange={(_: any, timeString: any) =>
                  onChangeTime(timeString, "auction_closing_duration")
                }
                disabled={
                  !canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES)
                }
                style={{ width: "100%" }}
              />
            </Col>
            <Col sm={24} lg={12} style={{ textAlign: "left" }}>
              <div style={{ marginBlock: "10px 7px" }}>
                <label style={{ color: "red" }}>* </label>
                Duration before which suppliers can see upcoming auction (HH:mm)
              </div>
              <TimePicker
                allowClear={false}
                showNow={false}
                format="HH:mm"
                placeholder="HH:mm"
                value={dayjs(formData.upcoming_auction_buffer_time, "HH:mm")}
                onChange={(_: any, timeString: any) =>
                  onChangeTime(timeString, "upcoming_auction_buffer_time")
                }
                disabled={
                  !canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES)
                }
                style={{ width: "100%" }}
              />
            </Col>
            <Col sm={24} lg={12} style={{ textAlign: "left" }}>
              <div style={{ marginBlock: "10px 7px" }}>
                <label style={{ color: "red" }}>* </label>
                Bag Type
              </div>
              <Select
                style={{ width: "100%", borderRadius: 10, textAlign: "left" }}
                // value={""}
                disabled={
                  !canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES)
                }
                value={formData.bag_type}
                onChange={(e) => onChangeInput(e, "bag_type")}
                placeholder="Select Bag Type"
                optionFilterProp="children"
              >
                {bagType.map((v: any, i) => {
                  return (
                    <Option key={i} value={v.parameter_data_value}>
                      {v.parameter_display_value}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col sm={24} lg={12} style={{ textAlign: "left" }}>
              <div style={{ marginBlock: "10px 7px" }}>
                <label style={{ color: "red" }}>* </label>
                Crop Year
              </div>
              <Select
                style={{ width: "100%", borderRadius: 10, textAlign: "left" }}
                disabled={
                  !canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES)
                }
                value={formData.crop_year}
                onChange={(e) => onChangeInput(e, "crop_year")}
                placeholder="Select crop year"
                optionFilterProp="children"
              >
                {cropYear.map((v: any, i) => {
                  return (
                    <Option key={i} value={v.crop_year}>
                      {v.crop_year}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col sm={24} lg={12} style={{ textAlign: "left" }}>
              <div style={{ marginBlock: "10px 7px" }}>
                <label style={{ color: "red" }}>* </label>
                Send WA for Upcoming Auction
              </div>
              <Switch
                onChange={(e) => onChangeInput(e, "send_wa_upcoming")}
                checked={formData.send_wa_upcoming === "1"}
                disabled={
                  !canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES)
                }
              />
            </Col>
            <div className="update-btn">
              <Button
                onClick={() => {}}
                disabled={
                  !canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES) ||
                  canUserAccess(user, FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS)
                }
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() =>
                  onUpdate(
                    [
                      "minimum_quantity",
                      "auction_closing_duration",
                      // "saudha_type",
                      "upcoming_auction_buffer_time",
                      "send_wa_upcoming",
                      "cash_discount",
                      "bag_type",
                      "crop_year",
                    ],
                    1,
                    false
                  )
                }
                disabled={
                  !canUserAccess(user, FeatureCodes.BRANCH_LEVEL_PREFERENCES) ||
                  canUserAccess(user, FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS)
                }
              >
                Update
              </Button>
            </div>
          </Row>
        </Spin>
      )}
    </div>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setBranch: (index: number) => dispatch(setSelectedBranch(index)),
    setCrop: (index: number) => dispatch(setSelectedCrop(index)),
    setRefetch: (status: boolean) => dispatch(setBranchParamsRefetch(status)),
  };
};
const mapStateToProps = createStructuredSelector({
  branches: selectBranches,
  varieties: selectVarieties,
  user: selectUserData,
  crops: selectCrops,
  selectedCrop: selectSelectedCrop,
  selectedBranch: selectSelectedBranch,
  currentpage: selectCurrentPage,
  branchParams: selectBranchParams,
  cropParams: selectCropParams,
  viewAuctionPage: selectViewAuctionPage,
  authData: selectAuthData,
});

export default connect(mapStateToProps, mapDispatchToProps)(SystemParameters);
